import React from 'react'
import { CButton, CCard, CCardBody, CCol, CRow } from '@coreui/react'
import WidgetsReminderConfig from '../widgets/WidgetsReminderConfig'
import { useNavigate } from 'react-router-dom'

const Wizard2 = () => {
  let navigate = useNavigate()

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={12}>
              <div>
                <h1>.</h1>
              </div>
              <h4 id="traffic" className="card-title mb-0">
                <p id="caption 1">Reminder - Configuration Wizard - Preferences</p>
              </h4>
            </CCol>
          </CRow>
          <CRow>{/*<WidgetsDropdown />*/}</CRow>
        </CCardBody>
      </CCard>
      <WidgetsReminderConfig />
      <CCard>
        <CCardBody>
          <CRow>
            <CCol sm={12}>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <CButton
                  color="primary"
                  onClick={() => {
                    //localStorage.removeItem('loginName1')
                    //localStorage.removeItem('wizard')
                    localStorage.setItem('wizard', 'Completed')
                    console.log('Configuration finished')
                    console.log('User: ' + localStorage.getItem('account_ID'))
                    navigate('/wizard3')
                  }}
                >
                  NEXT
                </CButton>
              </div>
            </CCol>
          </CRow>
          <CRow>{/*<WidgetsDropdown />*/}</CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Wizard2
